import axios from "axios";
const http = axios.create({
    baseURL: process.env.VUE_APP_ApiRoot,// 所有的请求地址前缀部分
    timeout: 80000, // 请求超时时间(毫秒)
    params:{
        callback: "",
        t: `_${Date.parse(new Date())}`,
    },
    // headers: {
    // 设置后端需要的传参类型
    // 'Content-Type': 'application/json',
    // 'token': x-auth-token',//一开始就要token
    // 'X-Requested-With': 'XMLHttpRequest',
    // },
});

// request请求拦截器
http.interceptors.request.use(
    config => {
        // 如果你要去localStor获取token,(如果你有)
        // let token = localStorage.getItem("x-auth-token");
        // if (token) {
                //添加请求头
                //config.headers["Authorization"]="Bearer "+ token
        // }
        return config
    },
    error => {
        // 对请求错误做些什么
        Promise.reject(error)
    }
)
// response响应拦截器
http.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        return response.data
    },
    error => {  
        let { res } = error;
        if (res) {
            switch (res.status) {
            case 401:
                break
            case 403:
                break
            case 404:
                break
            case 500:
                break
            }
        }
        // 对响应错误做点什么
        return Promise.reject(error)
    }
)
export default http;
